import { Button, Grid, GridItem, Link, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { useIntercom } from "react-use-intercom";
import { EmailInviteLanguage } from "../../autogen/bff-api";
import { setPreferredLanguage } from "../local-storage/language";

export const FooterLinks = () => {
  const { show } = useIntercom();

  const setLanguage = (language: EmailInviteLanguage) => {
    setPreferredLanguage(language);
    window.location.reload();
  };
  return (
    <Grid h="100%" gridTemplateColumns={`1fr 1fr 1fr 1fr`} gridTemplateRows={`1fr`}>
      <GridItem paddingTop={1}>
        <Text fontSize="md" color="smMuted">
          <b>{t("About")}</b>
        </Text>
        <Link fontSize="sm" color="smMuted" target="_blank" href="https://www.sourcemagnet.com">
          {t("Our vision")}
        </Link>
        <br />
        <Link fontSize="sm" color="smMuted" target="_blank" href="https://www.sourcemagnet.com/about-us">
          {t("The team")}
        </Link>
      </GridItem>
      <GridItem paddingTop={1}>
        <Text fontSize="md" color="smMuted">
          <b>{t("Terms")}</b>
        </Text>
        <Link fontSize="sm" color="smMuted" target="_blank" href="https://www.sourcemagnet.com/privacy-policy">
          {t("Privacy Policy")}
        </Link>
        <br />
        <Link fontSize="sm" color="smMuted" target="_blank" href="https://www.sourcemagnet.com/avtalevilkar">
          {t("Terms of Use")}
        </Link>
      </GridItem>
      <GridItem paddingTop={1}>
        <Text fontSize="md" color="smMuted">
          <b>{t("Support")}</b>
        </Text>
        <Button fontSize="sm" color="smMuted" variant="link" onClick={show} fontWeight="normal">
          {t("Contact us")}
        </Button>
      </GridItem>
      <GridItem paddingTop={1}>
        <Text fontSize="md" color="smMuted">
          <b>{t("Language")}</b>
        </Text>
        <Button
          fontSize="sm"
          color="smMuted"
          variant="link"
          onClick={() => setLanguage(EmailInviteLanguage.No)}
          fontWeight="normal"
        >
          {t("Norwegian")}
        </Button>
        <br />
        <Button
          fontSize="sm"
          color="smMuted"
          variant="link"
          onClick={() => setLanguage(EmailInviteLanguage.En)}
          fontWeight="normal"
        >
          {t("English")}
        </Button>
      </GridItem>
    </Grid>
  );
};
